import { Flex } from "antd";

function InfoRow({ label, value }: { label: string, value: string | React.ReactNode }) {
  return (
    <Flex gap={4} align="center">
      <span >{label}: </span>
      {
        typeof value === 'string' ? (
          <span className="font-bold">{value}</span>
        ) : (
          value
        )
      }
    </Flex>
  );
}

export default InfoRow;
